<template>
  <div>
    <div class="preview-transaction" @click="openTransaction">
      <div :class="['preview-transaction__inner-row', !isActiveColBorder ? 'border-bottom-row' : '']">
          <template v-for="({title, active}) in columns">
              <p class="preview-transaction__col"  v-if="title === 'date_of_creation' && active" >
                  {{ createdAt | getFormatDate('DD/MM/YYYY, HH:mm') }}
              </p>
              <p class="preview-transaction__col" v-else-if="title === 'type' && active">
                  {{ $t(type) }}
              </p>
              <p class="preview-transaction__col"
                 v-else-if="title === 'basis' && active"
              >
                  {{ $t(basis) || '-' }}
              </p>
              <p class="preview-transaction__col"
                 v-else-if="title === 'source' && active"
              >
                  {{ $t(source) || '-' }}
              </p>
              <p class="preview-transaction__col"
                 v-else-if="title === 'method' && active"
              >
                  {{ $t(method) }}
              </p>
              <div class="preview-transaction__col preview-transaction__currency"
                   v-else-if="title === 'CurrencyNetwork' && active"
              >
                  <template v-if="currencyTo">
                      <currency-network-icon  class="preview-transaction__currency-img" :currency="currencyName" :network="networkName" />
                      {{ currencyTo | getCurrencyTicker }} &nbsp;<span v-if="networkName" class="secondary-text">{{ networkName | getNetworkShortNameByNetworkName }}</span>
                  </template>
              </div>
              <template v-else-if="title === 'address_from' && active">
                  <div class="preview-transaction__col addressBookAlias preview-transaction__id"
                       v-if="data.addressFrom && !isAddressFromTransferType">
                      <template v-if="data.addressFrom">
                        <div class="df">
                          {{ data.addressFrom | preparedString }}
                          <copy :value="data.addressFrom" />
                        </div>

                          <div v-if="data.addressBookAlias" class="secondary-text">{{ data.addressBookAlias | getPrettyUrl }}</div>
                      </template>
                  </div>
                  <p class="preview-transaction__col" v-else-if="data.addressFrom && isAddressFromTransferType">
                      {{ addressFromTransfer }}</p>
                  <p class="preview-transaction__col" v-else>{{ '-' }}</p>
              </template>
              <template v-else-if="title === 'address_to' && active">
                  <div class="preview-transaction__col addressBookAlias  preview-transaction__id" v-if="data.addressTo && !isAddressToTransferType">
                      <template v-if="data.addressTo">
                          <div class="df">
                            {{ data.addressTo | preparedString }}
                            <copy :value="data.addressTo" />
                          </div>
                          <div v-if="data.addressBookToAlias" class="secondary-text">{{ data.addressBookToAlias | getPrettyUrl }}</div>
                      </template>

                  </div>
                  <p class="preview-transaction__col" v-else-if="data.addressTo && isAddressToTransferType">{{
                      addressToTransfer
                      }}</p>
                  <p class="preview-transaction__col" v-else>{{ '-' }}</p>
              </template>


              <div class="preview-transaction__col preview-transaction__id"
                   v-else-if="title === 'tx_hash' && active"
              >
                  <template v-if="data.txId && data.networkId">
                      <a :href="txLink(data.txId, data.networkId)" target="_blank">{{data.txId | preparedString }}</a>
                      <copy :value="txLink(data.txId, data.networkId)" />
                  </template>
                  <p v-else>{{ '-' }}</p>
              </div>
              <div class="preview-transaction__col preview-transaction__col_status"
                   v-else-if="title === 'status' && active"
              >
                  <div :class="['item__status', `item__status--${data.status}`]">
                      <span >{{ $t(status) }}</span>
                  </div>
              </div>

              <template v-if="title === 'debitCredit' && active">
                  <p class="preview-transaction__col preview-transaction__col_deposit  positive"
                     v-if="deposit && deposit !== 0 && !credit">
                      + {{ deposit }}
                  </p>
                  <p class="preview-transaction__col preview-transaction__col_deposit positive"  v-else-if="deposit === 0">
                      {{ deposit }}
                  </p>
                  <p class="preview-transaction__col preview-transaction__col_credit negative"  v-if="credit && credit !== 0 && !deposit">
                      - {{ credit }}
                  </p>
                  <p class="preview-transaction__col preview-transaction__col_credit negative"  v-else-if="credit === 0">
                      {{ credit }}
                  </p>
                  <div class="preview-transaction__col" v-else-if="credit && deposit">
                      <span class="preview-transaction__col_credit negative">{{ credit }}</span>
                      <span>&nbsp;&#x2192;&nbsp;</span>
                      <span class="preview-transaction__col_deposit positive">{{ deposit }}</span>
                  </div>
              </template>
          </template>
      </div>
    </div>
    <div :class="['preview-transaction_mobile']">
      <div :class="['preview-transaction__mobile']" >
          <div class="preview-transaction__preview" @click="openTransaction">
              <div :class="['preview-transaction__info-status', `preview-transaction__info-status--${data.status}`]"></div>
              <div class="preview-transaction__currency" :style="`--colorStatus:${mobileStatusTextColor};`">
                  <div class="preview-transaction__currency-container">

                      <p class="preview-transaction__currency-text">
                          {{ $t(type) }}
                      </p>
                      <p class="secondary-text">{{ id | preparedString }}</p>
                  </div>

              </div>

              <div class="preview-transaction__amount-container">
                  <p class="preview-transaction__preview-text preview-transaction__preview-text_deposit positive"
                     v-if="deposit !== 0 && deposit && !credit">
                      + {{ deposit }}
                  </p>

                  <p class="preview-transaction__preview-text preview-transaction__preview-text_deposit positive"
                     v-else-if="deposit === 0 && !credit">
                      {{ deposit }}
                  </p>

                  <p class="preview-transaction__preview-text  preview-transaction__preview-text_credit negative"
                     v-if="credit !== 0 && credit && !deposit">
                      - {{ credit }}
                  </p>
                  <p class="preview-transaction__preview-text preview-transaction__preview-text_credit negative"
                     v-else-if="credit === 0 && !deposit">
                      {{ credit }}
                  </p>
                  <div class="preview-transaction__preview-text preview-transaction__preview-text_deposit"
                       v-else-if="credit && deposit">
                  <span class="preview-transaction__preview-text preview-transaction__preview-text_credit positive">{{
                      credit
                      }}</span>
                      <span>&nbsp;&#x2192;&nbsp;</span>
                      <span class="preview-transaction__preview-text preview-transaction__preview-text_deposit negative">{{
                          deposit
                          }}</span>
                  </div>
                  <span class="secondary-text">{{ currencyTo | getCurrencyTicker }}<template v-if="networkId">&nbsp;{{ networkName | getNetworkShortNameByNetworkName }}</template></span>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import AtCollapse from 'at-ui/src/components/collapse/';
import AtCollapseItem from 'at-ui/src/components/collapse-item/';
import CopyString from "/public/components/elements/CopyString";
import CurrencyImg from "/public/components/elements/CurrencyImg";
import {
    getCurrencyInfoById,
    getNetworkSystemName,
    transactionHistoryBasis,
    transactionHistorySource,
    transactionHistoryStatus,
    transactionHistoryType, transferAddressType,
} from "../../../filters";
import {TRANSACTION_HISTORY_STATUS_ENUM} from "../../../../common/constants/transaction-history-status-enum";
import BigNumber from "bignumber.js";
import Copy from "@/public/components/common/copy.vue";
import CurrencyNetworkIcon from "@/public/components/elements/orphan/Select/CurrencyNetworkIcon.vue";
import {BlockchainLinks} from "@/public/mixins/blockchain-links";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";

export default {
    name: 'PreviewTransaction',
    components: {
        BaseButton,
        CurrencyNetworkIcon,
        Copy,
        CopyString,
        CurrencyImg,
        AtCollapse,
        AtCollapseItem,
    },
    mixins: [
        BlockchainLinks,
    ],
    props: {
        data: {
            type: Object,
            required: true,
        },
        routeName: {
            type: String,
            default: 'transaction',
        },
    },
    data() {
        return {
            isPreviewOpened: false
        }
    },
    computed: {
        ...mapState('app', [
            'currencies',
        ]),
        ...mapState('transactions', ['columns']),
        activeColumnsCount () {
          return this.columns.filter(({active}) => active).length
        },
        isActiveColBorder () {
            return this.activeColumnsCount > 4
        },
        networkName() {
            const name = getNetworkSystemName(this.networkId);
            return name === '-' ? '' : name
        },
        id() {
            return this.data.id;
        },
        type() {
            return transactionHistoryType(this.data.type);
        },
        status() {
            return transactionHistoryStatus(this.data.status);
        },
        basis() {
            return transactionHistoryBasis(this.data.basis);
        },
        source() {
            return transactionHistorySource(this.data.side);
        },
        createdAt() {
            return this.data.createdAt;
        },
        method() {
            return this.$options.filters.transactionHistoryMethod(this.data.source);
        },
        networkId() {
            return this.data.networkId;
        },
        isAddressToTransferType() {
            const ADDRESS_TYPE = {
                PAY_IN: 'transactions.transfer_type.pay_in',
                PAY_OUT: 'transactions.transfer_type.pay_out',
                ADVANCE: 'transactions.transfer_type.advance',
            };
            return ADDRESS_TYPE[this.data.addressTo] || false;
        },
        isAddressFromTransferType() {
            const ADDRESS_TYPE = {
                PAY_IN: 'transactions.transfer_type.pay_in',
                PAY_OUT: 'transactions.transfer_type.pay_out',
                ADVANCE: 'transactions.transfer_type.advance',
            };
            return ADDRESS_TYPE[this.data.addressFrom] || false;
        },
        currencyFrom() {
            const {
                data: {
                    currencyFrom,
                },
            } = this;

            return currencyFrom;
        },
        currencyTo() {
            const {
                data: {
                    currencyId,
                },
            } = this;

            return currencyId;
        },
        currencyName () {
          return getCurrencyInfoById(this.data.currencyId).currency
        },
        mobileStatusTextColor() {
            switch (this.data.status) {
            case TRANSACTION_HISTORY_STATUS_ENUM.INIT:
                return '#6190e8';
            case TRANSACTION_HISTORY_STATUS_ENUM.PROCESSED:
                return '#13ce66';
            case TRANSACTION_HISTORY_STATUS_ENUM.PENDING:
                return '#6190e8';
            case TRANSACTION_HISTORY_STATUS_ENUM.ERROR:
                return '#EB5757';
            case TRANSACTION_HISTORY_STATUS_ENUM.REJECTED:
                return '#EB5757';
            default:
                return '#8F949A';
            }
        },
        hasCurrencyFrom() {
            return Boolean(this.currencyFrom);
        },
        hasCurrencyTo() {
            return Boolean(this.currencyTo);
        },
        orderId() {
            return this.data.orderId;
        },
        hasOrderId() {
            return Boolean(this.orderId);
        },
        orderCreatedAt() {
            return this.data.orderCreatedAt;
        },
        credit() {
            if (this.data.credit) {
                const credit = new BigNumber(this.data.credit);
                return credit.decimalPlaces(8).toNumber();
            }
            return null;
        },
        deposit() {
            if (this.data.deposit) {
                const credit = new BigNumber(this.data.deposit);
                return credit.decimalPlaces(8).toNumber();
            }
            return null;
        },
        id_copied() {
            return this.$t('copy.id_copied');
        },
        id_not_copied() {
            return this.$t('copy.id_not_copied');
        },
        notification() {
            return this.$t('copy.notification');
        },
        addressToTransfer() {
            return this.$t(this.$options.filters.transferAddressType(this.data.addressTo));
        },
        addressFromTransfer() {
            return this.$t(this.$options.filters.transferAddressType(this.data.addressFrom));
        },
    },
    methods: {
        openTransaction () {
            this.$emit('openTransaction', this.id)
        },
        txLink(txId, networkId) {
            return this.$txLink(txId, networkId);
        },
        togglePreview () {
            this.isPreviewOpened = !this.isPreviewOpened
        }
    }
};

</script>

<style lang="scss" scoped>
p {
    color: var(--new-front-primary-font-color);
}
.border-bottom-row {
  border-bottom: 1px solid var(--new-front-divider-color);
    .preview-transaction__col {
        border-bottom: none;
    }
}
.secondary-text {
  color: var(--new-front-secondary-font-color);
    font-weight: 500;
}
.preview-transaction__amount-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.preview-transaction__info-status {
    width: 3px;
    height: 55px;
    border-radius: 13px;
    position: absolute;
    left: 0;
    padding: 0;
    &--init {
        background: var(--new-front-status-text-active);
    }
    &--expired {
        background: var(--new-front-status-text-expired);
    }
    &--processed {
        background: var(--new-front-status-text-processed);
    }
    &--pending {
        background: var(--new-front-status-text-pending);
    }
    &--partial {
        background: var(--new-front-status-text-pending);
    }
    &--error {
        background: var(--new-front-status-text-error);
    }
    &--rejected {
        background: var(--new-front-status-text-error);
    }
}
.item__status {
  width: 130px;
  height: 32px;
  border-radius: 10px;
  text-align: center;
  padding: 5px 15px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  &--init {
    color: var(--new-front-status-text-active);
    background: var(--new-front-status-active);
  }
  &--expired {
    color: var(--new-front-status-text-expired);
    background: var(--new-front-status-expired);
  }
  &--processed {
    color: var(--new-front-status-text-processed);
    background: var(--new-front-status-processed);
  }
  &--pending {
      color: var(--new-front-status-text-pending);
      background: var(--new-front-status-pending);
  }
  &--partial {
    color: var(--new-front-status-text-pending);
    background: var(--new-front-status-pending);
  }
  &--error {
    color: var(--new-front-status-text-error);
    background: var(--new-front-status-error);
  }
    &--rejected {
        color: var(--new-front-status-text-error);
        background: var(--new-front-status-error);
    }
  @media (max-width: 950px) {
    font-size: 13px;
  }
}
.preview-transaction {
  padding: 0;
  position: relative;
  color: var(--new-front-primary-font-color);
  cursor: pointer;
&__btn {
    margin-top: 20px;
}
  &_mobile {
    display: none;
  }
    &__chevron {
        position: absolute;
        right: 25px;
        transition: transform .3s ease;
        &--active {
            transform: rotate(180deg);
        }
    }
  &:hover {

    & .preview-transaction__col {
      background-color: var(--new-front-main-bg);
    }

  }

  &__inner-row {
    display: grid;
    grid-template-columns: repeat(11, 25%);
    width: 100%;
    min-height: 88px;
    align-items: center;
  }

  &__write_off_currency {
    text-align: start;

  }

  &__col {
    font-size: $h4;
    font-weight: 500;
    font-family: $Gilroy;
    line-height: var(--line-height);
    color: var(--new-front-primary-font-color);
    text-align: start;
    min-height: 85px;
    display: flex;
    align-items: center;
    word-break: break-word;
      border-bottom: 1px solid var(--new-front-divider-color);
    a {
      color: var(--new-front-purple);
    }
    //
    //&_deposit {
    //  color: var(--green-200);
    //}
    //
    //&_credit {
    //  color: var(--red-200);
    //}

    //&_status {
    //  color: var(--colorStatus);
    //}

    &:first-child {
      padding-left: 40px;
    }

    &:last-child {
      padding-right: 40px;
      //justify-content: flex-end;
    }
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 255%;
    height: 100%;
    z-index: 0;
  }

  &__id {
    position: relative;
    z-index: 2;
    a {
      color: var(--new-front-purple);
    }
  }

  &__currency {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  &__currency_write-off {
    align-items: center;
  }

  &__currency-img {
    margin-right: 12px;
    width: 24px;
    height: 24px;
  }
}

@media screen and (max-width: 1330px) {
  .preview-transaction {
    &__col {
      &:first-child {
        padding-left: 15px;
      }

      &:last-child {
        padding-right: 15px;
      }
    }
  }

}

@media screen and (max-width: 950px) {
    ::v-deep {
        .copy-wrapper {
            margin-right: 0;
        }
    }
  .preview-transaction {

    display: none;

    &__title-text {
      font-size: $h6;
      font-family: $Gilroy;
      line-height: var(--line-height);
      color: var(--new-front-primary-font-color);
      text-align: right;

      &_secondary {
        color: var(--new-front-secondary-font-color);
          font-weight: 500;
      }
    }

    &__row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 53px;
      border-bottom: 1px solid var(--new-front-divider-color);
      color: var(--new-front-primary-font-color);
        font-size: $h6;
        font-weight: 500;
        a {
            color: var(--new-front-purple);
        }
        &:last-of-type {
            margin-bottom: 20px;
        }
      ::v-deep .copy-string__string {
        font-family: $Gilroy;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
        color: var(--new-front-primary-font-color);
      }
        &-value {
            display: flex;
            align-items: center;
        }
    }

    &__preview-text {
        font-size: $h6;
        font-weight: 500;
      font-family: $Gilroy;
      line-height: var(--line-height);
      color: var(--new-front-primary-font-color);
      text-align: right;

      //&_deposit {
      //  color: var(--green-200);
      //}
      //
      //&_credit {
      //  color: var(--red-200);
      //}
    }

    &__currency {
      &-status {
        font-family: $Gilroy;
        font-style: normal;
        font-weight: 400;
        font-size: var(--font-size-text-caption);
        line-height: var(--line-height);
        color: var(--colorStatus);
      }

      &-text {
        font-size: var(--font-size-text-main);
        font-family: $Gilroy;
        line-height: var(--line-height);
        color: var(--new-front-primary-font-color);


      }
    }

    &_mobile {
      display: block;
        max-height: 68px;
        overflow: hidden;
        transition: max-height .3s ease;
        border-bottom: 1px solid var(--new-front-divider-color);
        &--active {
            max-height: 650px;
        }
    }

    &__preview {
      display: flex;
      justify-content: space-between;
      flex: 1;
      padding-right: 20px;
        padding-left: 20px;
      align-items: center;
        min-height: 68px;
        cursor: pointer;
        position: relative;
    }

    &__read-more {
      width: 100%;
      max-width: 300px;
      border-radius: 12px;
      background: #0059F7;
      font-size: var(--font-size-text-main);
      font-family: $Gilroy;
      line-height: var(--line-height);
      text-align: center;
      color: var(--white-100);
      min-height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 25px;
      margin-bottom: 20px;
    }

    &__detailed-info {
      align-items: center;
      display: flex;
      flex-direction: column;
        padding: 0 20px;
        margin-bottom: 20px;
    }

    &__mobile {
      display: block;

      ::v-deep .at-collapse {
        border: 1px solid var(--new-front-divider-color);
        border-right: none;
        border-left: none;
      }

      ::v-deep .at-collapse__content {
        padding: 0 10px;
        background: var(--secondary-color);
      }

      ::v-deep .at-collapse__header {
        background: var(--secondary-color);
        min-height: 50px;
        display: flex;
        align-items: center;
        padding: 0 10px;
      }

      ::v-deep .at-collapse__icon {
        right: 10px;
        top: 17px;
        font-size: 20px;
        left: unset;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }

      ::v-deep .at-collapse__item--active > .at-collapse__header .at-collapse__icon {
        -webkit-transform: rotate(270deg);
        transform: rotate(270deg);
      }
    }
  }
}

.positive {
    color: var(--new-front-text-success-bg-secondary) !important;
}
.negative {
    color: var(--new-front-status-text-error) !important;
}
.df {
  display: flex;
}
.addressBookAlias {
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 5px
}
</style>
